/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class ComplaintListModel extends JSONable {

  uuid: string | undefined = undefined;

  parentUuid: string | undefined = undefined;

  orderUuid: string | undefined = undefined;

  message: string | undefined = undefined;

  createdAt: string | undefined = undefined;

  orderNumber: string | undefined = undefined;

  customerUuid: string | undefined = undefined;

  serviceProviderUuid: string | undefined = undefined;

  lastReplyBy: string | undefined = undefined;

  status: string | undefined = undefined;
}
